import { useKFlags } from '@/hooks/use-k-flags';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const NotificationLink = ({
  label,
  to,
  notification,
  onClose,
  className = '',
}) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { ats_enabled } = useKFlags();

  const handleNotificationClick = async () => {
    onClose();
    try {
      markAsRead({ id: notification?.id });
    } catch (error) {
      console.error('Notification link - readby failed');
    }
  };

  return (
    <Text as="span" px="4px" onClick={handleNotificationClick}>
      <Link
        to={to}
        style={{ fontWeight: '700' }}
        className={ats_enabled ? 'ats-notification-link' : ''}
      >
        {label}
      </Link>
    </Text>
  );
};
